<template>
  <div class="relative">
    <div
      :v-show="isAnimated"
      class="absolute right-0 p-1 bg-red-400 border rounded-full animate-ping"
    />
    <div
      :v-if="isAnimated || hasNotification"
      class="absolute right-0 p-1 bg-red-400 border rounded-full"
    />
    <button
      @click="emit('on-click')"
      class="p-2 bg-gray-100 rounded-full hover:bg-gray-300 focus:outline-none focus:ring"
    >
      <base-icon :iconName="iconName" />
    </button>
  </div>
</template>

<script lang='ts'>
import { BaseIcon } from "components/atoms";
import { iconN } from "assets/icons";

export default {
  name: "NotificationButton",
  components: { BaseIcon },
  props: {
    iconName: { type: String as () => iconN, required: true },
    isAnimated: { type: Boolean, default: false },
    hasNotification: { type: Boolean, default: false },
  },
  emits: ["on-click"],
};
</script>
